// extracted by mini-css-extract-plugin
module.exports = {"section":"PreviewSection_section_3xefH","slides":"PreviewSection_slides_Fpy6g","play":"PreviewSection_play_GZAAh"};